import { useContext, useState, useEffect } from "react";
import CartContext from "../../store/cart-context";

import classes from "./HeaderCartButton.module.css";
// https://react-icons.github.io/react-icons/icons?name=fa
import { FaShoppingCart } from "react-icons/fa";

// Wordt aangeroepen vanuit Header
const HeaderCartButton = (props) => {
  const [btnIsHighlighted, setBtnIsHighlighted] = useState(false);
  const cartCtx = useContext(CartContext);
  console.log(cartCtx);

  // Object destructuring
  const { items } = cartCtx;

  // 0 = startwaarde
  const numberOfCartItems = items.reduce((curNumber, item) => {
    console.log("curNumber: " + curNumber);
    console.log("item.aankoophoeveelheid: " + item.aankoophoeveelheid);
    return curNumber + item.aankoophoeveelheid;
  }, 0);

  const btnClasses = `${classes.button} ${
    btnIsHighlighted ? classes.bump : ""
  }`;

  useEffect(() => {
    if (items.length === 0) {
      return;
    }
    setBtnIsHighlighted(true);

    const timer = setTimeout(() => {
      setBtnIsHighlighted(false);
    }, 300);

    // Cleanup function
    return () => {
      clearTimeout(timer);
    };
  }, [items]);

  return (
    <button className={btnClasses} onClick={props.onClick}>
      <span className={classes.icon}>
        <FaShoppingCart />
      </span>
      <span>Winkelwagen</span>
      <span className={classes.badge}>{numberOfCartItems}</span>
    </button>
  );
};

export default HeaderCartButton;
